import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Orbit as OrbitIcon } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const tenantSlug = params.get("tenant") || "";
  const isInvite = params.get("invite") === "1";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      const slug = data?.tenant_slug || tenantSlug;
      if (slug) localStorage.setItem("orbit_tenant", slug);
      toast.success(isInvite ? "Mot de passe créé. Connectez-vous." : "Mot de passe réinitialisé.");
      nav("/login");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-indigo-600 grid place-items-center text-white"><OrbitIcon className="w-5 h-5"/></div>
          <div className="font-display font-bold text-xl">ORBIT</div>
        </div>
        <h2 className="font-display text-3xl font-bold text-slate-900">Nouveau mot de passe</h2>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)}
                 placeholder="Nouveau mot de passe"
                 className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400"/>
          <button data-testid="reset-submit" disabled={loading || !token} className="w-full py-3 rounded-xl bg-indigo-600 text-white font-semibold disabled:opacity-60">
            {loading ? "…" : "Réinitialiser"}
          </button>
        </form>
        <Link to="/login" className="block mt-6 text-center text-sm text-indigo-600 hover:underline">Retour à la connexion</Link>
      </div>
    </div>
  );
}
